import { SkillsMemberCertificationModelList } from 'generated-types/skills/certification';
import { SkillsEducationModelList } from 'generated-types/skills/education';
import { SkillsExperienceModelList, SkillsSkillModelList } from 'generated-types/skills/experience';
import { SkillsMemberModel } from 'generated-types/skills/member';
import { ResumeProfileModel } from 'generated-types/skills/resume_profile';

import { Certifications } from './Certifications';
import { Educations } from './Educations';
import { Experiences } from './Experiences';
import { Profile } from './Profile';
import { Skills } from './Skills';
import { Dispatch, SetStateAction } from 'react';

export const CVEditor = ({
    selectedResumeProfile,
    setSelectedResumeProfile,
    resumeProfiles,
    editAllowed,
    skillsMember,
    memberSkills,
    circlesExperiences,
    otherExperiences,
    educations,
    experiencesLoading,
    educationsLoading,
    skillsLoading,
    memberCertifications,
    certificationsLoading,
}: {
    selectedResumeProfile: ResumeProfileModel;
    setSelectedResumeProfile: Dispatch<SetStateAction<ResumeProfileModel | undefined>>;
    resumeProfiles: ResumeProfileModel[];
    editAllowed: boolean;
    skillsMember: SkillsMemberModel;
    memberSkills: SkillsSkillModelList;
    circlesExperiences: SkillsExperienceModelList;
    otherExperiences: SkillsExperienceModelList;
    educations: SkillsEducationModelList;
    experiencesLoading: boolean;
    educationsLoading: boolean;
    skillsLoading: boolean;
    memberCertifications: SkillsMemberCertificationModelList;
    certificationsLoading: boolean;
}) => (
    <>
        <Profile
            member={skillsMember}
            editAllowed={editAllowed}
            selectedResumeProfile={selectedResumeProfile}
            setSelectedResumeProfile={setSelectedResumeProfile}
            resumeProfiles={resumeProfiles}
        />
        <Skills
            setSelectedResumeProfile={setSelectedResumeProfile}
            selectedResumeProfile={selectedResumeProfile}
            memberSkills={memberSkills}
            editAllowed={editAllowed}
            skillsLoading={skillsLoading}
        />
        <Experiences
            selectedResumeProfile={selectedResumeProfile}
            editAllowed={editAllowed}
            circlesExperiences={circlesExperiences}
            otherExperiences={otherExperiences}
            experiencesLoading={experiencesLoading}
        />
        <Educations
            editAllowed={editAllowed}
            educations={educations}
            educationsLoading={educationsLoading}
        />
        <Certifications
            memberCertifications={memberCertifications}
            certificationsLoading={certificationsLoading}
            editAllowed={editAllowed}
        />
    </>
);
